import React from "react"
import ReactDOM from "react-dom"

import App from "./werkplaatsafspraak/App"

ReactDOM.render(
    React.createElement(App),
    document.querySelector("#werkplaatsafspraak_root")
)
